import { Box, CircularProgress, Typography } from "@mui/material";
import { useLinkSections } from "../../hooks/useLinks";
import HsvDivider from "../HsvDivider/HsvDivider";
import LinksItem from "./LinksItem/LinksItem";
import * as styles from "./linksStyles";

const Links: React.FC = () => {
    const { data: sections, isLoading } = useLinkSections();

    if (isLoading) {
        return (
            <Box sx={styles.linksContainerStyles}>
                <Box display="flex" justifyContent="center" py={4}>
                    <CircularProgress />
                </Box>
            </Box>
        );
    }

    return (
        <Box sx={styles.linksContainerStyles}>
            {sections?.map((section, i) => (
                <Box key={section.id}>
                    {/* the first section sits directly below the hero, so it only gets a divider when it has a logo */}
                    {(section.logoUrl || i > 0) && (
                        <Box sx={styles.dividerWrapperStyles}>
                            <HsvDivider>
                                {section.logoUrl ? (
                                    <Box
                                        component="img"
                                        sx={styles.sectionLogo}
                                        alt={`${section.title} Logo`}
                                        src={section.logoUrl}
                                    />
                                ) : (
                                    <Typography sx={styles.sectionTitle}>
                                        {section.title}
                                    </Typography>
                                )}
                            </HsvDivider>
                        </Box>
                    )}

                    <LinksItem links={section.links} />
                </Box>
            ))}
        </Box>
    );
};

export default Links;
